import styled from 'styled-components';
import Pagination from '@material-ui/lab/Pagination'


export const StyledPagination = styled(Pagination)`
    margin: 30px 0px;
    margin-bottom: 20px
`;
export const SetFlex = styled.div`
    display: flex;
    justify-content: center;
    width:100%
`